import { SocialApplyStatus } from "@bbj-types/socialApply/enum";
import { Stack } from "@mui/material";
import { NoResult, NoResultEmptyImage } from "@styleguide";
import { CandidatesListProvider } from "./context";
import { SocialOffersDetailsFilters } from "./filters";
import { useSocialOffersDetailsBody } from "./logics";
import type { TCandidateFilters } from "./logics/types";
import { SocialApplyCardSkeleton } from "./skeleton";
import { SocialOffersDetailsTable } from "./tables";
import { SocialOffersDetailsTabs } from "./tabs";

interface ISocialOffersDetailsBodyProps {
  offerId: string;
}

interface INoResultMessageProps {
  hasFilters: boolean;
  tab: string;
}

const NO_RESULT_TEXT = {
  [SocialApplyStatus.PRESCRIPTION_FILLED]: `Aucun candidat ne fait l'objet d'une prescription sur cette offre en ce moment. Les candidats concernés apparaîtront ici dès qu'une prescription aura lieu.`,
  [SocialApplyStatus.INTEGRATED_CANDIDATE]:
    "Aucun candidat n'a fait l'objet d'une intégration sur cette offre pour le moment. Lorsque des candidats seront intégrés, vous les verrez apparaître ici.",
  [SocialApplyStatus.REFUSED_STRUCTURE]:
    "Aucun candidat n'a fait l'objet d'un refus sur cette offre pour le moment. Lorsque des candidats seront refusés, vous les verrez apparaître ici.",
  default:
    "Votre recherche est trop précise ! Veuillez modifier ou supprimer certains des filtres activés pour voir des résultats apparaître.",
};

const NoResultMessage = ({ hasFilters, tab }: INoResultMessageProps) => {
  return;
};

const hasActiveFilter = (filters: TCandidateFilters): boolean => {
  return filters.place.length > 0 || !!filters.search || filters.status.length > 0;
};

export const SocialOffersDetailsBody = ({ offerId }: ISocialOffersDetailsBodyProps) => {
  const {
    changeTab,
    refetchApplies,
    selectedTab,
    applyCount,
    applies,
    setApplies,
    loading,
    filters,
    dispatch,
    socialApplySelected,
    setSocialApplySelected,
  } = useSocialOffersDetailsBody(offerId);
  return (
    <CandidatesListProvider
      total={applies?.length ?? 0}
      applies={applies}
      setApplies={setApplies}
      socialApplySelected={socialApplySelected}
      setSocialApplySelected={setSocialApplySelected}
      changeTab={changeTab}
    >
      <Stack sx={{ flex: "1 1 auto", gap: 2 }}>
        <SocialOffersDetailsFilters filters={filters} dispatch={dispatch} />
        <SocialOffersDetailsTabs changeTab={changeTab} selectedTab={selectedTab} applyCount={applyCount} />
        {loading ? (
          <SocialApplyCardSkeleton />
        ) : applies && applies.length > 0 ? (
          <SocialOffersDetailsTable tab={selectedTab} data={applies} refetchApplies={refetchApplies} />
        ) : (
          <NoResult
            text={NO_RESULT_TEXT[!hasActiveFilter(filters) ? selectedTab : "default"]}
            image={<NoResultEmptyImage />}
          />
        )}
      </Stack>
    </CandidatesListProvider>
  );
};
